import { SoNumeros } from "src/hook/Functions";
import yup from "src/validators/yup.Module";
import { validateCNPJ, validateCPF } from "validations-br";
import { DestinatarioNFCeDto, MeioPagamentoNFCeDto } from "./../NFCe.Dto";

export interface NFCeModalFinalizarProps {
  show: boolean;
  onHide: () => void;
  onSelect: (value: MeioPagamentoNFCeDto) => void;
  onCancel: () => void;
  onSubmit: (value: DestinatarioNFCeDto | undefined) => void;
  totalNFCe: number;
  dataMeioPagamento: MeioPagamentoNFCeDto[];
}

export const NFCeModalPagamentoSchema = yup.object().shape({
  valorPagamento: yup.mixed().required("Informe o valor pagamento "),
});

export const NFCeModalDestinatarioSchema = yup.object().shape({
  cnpj: yup
    .string()
    .nullable()
    .test("documento", "CPF/CNPJ inválido", (value) => {
      if (!value || value.trim() === "") return true;
      const numericValue = SoNumeros(value);
      if (numericValue.length === 14) {
        return validateCNPJ(value);
      } else if (numericValue.length === 11) {
        return validateCPF(value);
      }
      return false;
    }),
  nome: yup
    .string()
    .nullable()
    .test(
      "conditional-nome",
      "O campo nome só pode ser preenchido caso o CPF/CNPJ seja válido.",
      function (value) {
        if (!value || value.trim() === "") return true;
        const { documento } = this.parent;
        const numericValue = SoNumeros(documento);
        if (
          !numericValue ||
          !(validateCPF(numericValue) || validateCNPJ(numericValue))
        ) {
          return !value || value.trim() === "";
        }
        return true;
      }
    )
    .test(
      "length-nome",
      "O nome deve ter entre 3 e 60 caracteres.",
      function (value) {
        if (!value || value.trim() === "") return true;
        return value.length >= 3 && value.length <= 60;
      }
    ),
});
